import React from 'react'
import Select from 'react-select'

export default class SelectObject extends React.Component {
  constructor(props) {
    super(props)
  }

  getOptions() {
    // return { label: objectValue, value: objectId }
    return this.props.objectList.map((object) => {
      const keys = Object.keys(object)
      return {
        label: object[keys[1]],
        value: object[keys[0]]
      }
    })
  }

  render() {
    return (
      <Select
        options={this.getOptions()}
        clearable={false}
        {...this.props}
      />
    )
  }
}


// WEBPACK FOOTER //
// ./src/component/element/SelectObject.js